import { useServicesContext } from '../context';
export function getCashPurchasePrice(vehicle) {
    if (!vehicle) {
        return undefined;
    }
    const { typedPrices } = vehicle;
    for (const typedPrice of typedPrices) {
        if (typedPrice.type === 'retail') {
            return typedPrice.amount;
        }
    }
    return undefined;
}
export function getCashCheckout(vehicleBasic) {
    if (!vehicleBasic) {
        return undefined;
    }
    const purchasePrice = getCashPurchasePrice(vehicleBasic);
    if (purchasePrice === undefined) {
        return undefined;
    }
    return {
        brand: 'Audi',
        ecommerceCheckoutType: 'STOCK_CAR_SALES',
        vehicleIdentifier: vehicleBasic.carId,
        financialProduct: 'CASH',
        vehiclePurchasePrice: `${purchasePrice}`,
        dealerId: vehicleBasic.dealer.id,
        vehicleCondition: vehicleBasic.type === 'N' ? 'NEW_CAR' : 'USED_CAR',
    };
}
export function getFinancingCheckout(vehicleBasic, webCalcRequest) {
    if (!vehicleBasic || !webCalcRequest) {
        return undefined;
    }
    const financeRequest = {
        Request: webCalcRequest,
    };
    return {
        brand: 'Audi',
        ecommerceCheckoutType: 'STOCK_CAR_SALES',
        vehicleIdentifier: vehicleBasic.carId,
        financialProduct: 'FINANCING',
        dealerId: vehicleBasic.dealer.id,
        webCalcRequest: financeRequest,
        vehicleType: 'VTP_CARID',
        vehicleCondition: vehicleBasic.type === 'N' ? 'NEW_CAR' : 'USED_CAR',
    };
}
export function isButtonForFinanceProduct(button, financeProductId) {
    const financeProductIds = button.glcFinancingProductIds.split(',').map((item) => item.trim());
    return financeProductIds.indexOf(financeProductId) !== -1;
}
export function isButtonConfiguredForSelectedFinanceProduct(button, financeData) {
    const currentFinanceProductId = (financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData)
        ? financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData['@ID']
        : 'PRODUCT_NOT_FOUND';
    if (!currentFinanceProductId ||
        currentFinanceProductId.length === 0 ||
        !button.glcFinancingProductIds) {
        return false;
    }
    return isButtonForFinanceProduct(button, currentFinanceProductId);
}
export function getFinanceDataFromStore(vehicleBasic) {
    if (!vehicleBasic || !vehicleBasic.type) {
        return undefined;
    }
    const storeName = vehicleBasic.type.toUpperCase() === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
    const storeData = readFinanceFromSessionStore(storeName);
    if (storeData && (storeData === null || storeData === void 0 ? void 0 : storeData.financing)) {
        return storeData.financing[vehicleBasic.id];
    }
    return undefined;
}
export function isGroupLeanCashCheckoutButton(button) {
    return button && button.type === 'glc-cash-checkout';
}
export function isGroupLeanFinancingCheckoutButton(button) {
    return button && button.type === 'glc-financing-checkout';
}
export function isGroupLeanCheckoutButton(button) {
    return isGroupLeanCashCheckoutButton(button) || isGroupLeanFinancingCheckoutButton(button);
}
export function isFinanceCheckoutButton(button) {
    return button && button.type === 'finance-checkout';
}
export function getLeanCheckoutBackendForButton(button, eCommerceService, vehicle) {
    let checkoutBackend;
    if (isGroupLeanCheckoutButton(button)) {
        if (isGroupLeanCashCheckoutButton(button)) {
            checkoutBackend = eCommerceService ? getCashCheckout(vehicle) : undefined;
        }
        else {
            const financeData = getFinanceDataFromStore(vehicle);
            if (financeData && isButtonConfiguredForSelectedFinanceProduct(button, financeData)) {
                checkoutBackend =
                    eCommerceService && financeData && financeData.financeRequestData
                        ? getFinancingCheckout(vehicle, financeData.financeRequestData.Request)
                        : undefined;
            }
        }
    }
    return checkoutBackend;
}
export function getButtonForProduct(financeProductId) {
    var _a, _b, _c, _d, _e;
    const servicesContext = useServicesContext();
    const audiContentService = servicesContext.getAdditionalService('audi-content-service');
    const configuration = (_c = (_b = (_a = audiContentService.getContent()) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.vtpConfiguration) === null || _c === void 0 ? void 0 : _c.fields;
    const rawCTAButtons = (_e = (_d = configuration.cta) === null || _d === void 0 ? void 0 : _d.map((button) => button.fields)) !== null && _e !== void 0 ? _e : [];
    for (const button of rawCTAButtons) {
        if (isGroupLeanFinancingCheckoutButton(button) &&
            isButtonForFinanceProduct(button, financeProductId)) {
            return button;
        }
    }
    return undefined;
}
export function readFinanceFromSessionStore(storeName) {
    let sessionStorageData;
    try {
        if (typeof window !== 'undefined') {
            const storageData = sessionStorage.getItem(storeName);
            sessionStorageData = JSON.parse(storageData);
        }
    }
    catch (e) {
        console.error('Failed to parse session storage data', e);
        sessionStorageData = null;
    }
    return sessionStorageData;
}
export function getFinanceProductIdFromFinanceData(financeData) {
    var _a, _b, _c, _d;
    const product = ((_b = (_a = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _a === void 0 ? void 0 : _a.Request) === null || _b === void 0 ? void 0 : _b.Product)
        ? (_d = (_c = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _c === void 0 ? void 0 : _c.Request) === null || _d === void 0 ? void 0 : _d.Product
        : financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData;
    return product ? product['@ID'] : '';
}
